import React from 'react';
import '../css/CardMenu.css';
import CoinIcon from './CoinIcon';

const TokenFastForwardMenu = ({ price, onFastForward, onCancel, timeLeft, loading, error }) => {
    return (
        <div className="card-menu" onClick={(e) => e.stopPropagation()}>
            <div className='card-menu-container'>
                <h1 className='title-events'>Token Refresh</h1>
                <button className="overlay-close" onClick={onCancel}>X</button>
                <div className='card-menu-content' style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <div className='col-3 card-menu-option'>
                        <button className='default-button big' onClick={onFastForward} disabled={loading}>
                            {loading ? <div className="loader"></div> : 'Refresh Token'}
                        </button>
                        <span className='subtitle-card-menu'>
                            <CoinIcon width="1.4vw" height="1.4vw" />
                            <p> {price} </p>
                        </span>
                    </div>
                    {error && <div className='error'>{error}</div>}
                </div>
            </div>
        </div>
    );
};

export default TokenFastForwardMenu;
